import { useState, useRef, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import DateRanges from '@app/dashboard/components/inner_layout/DateRanges';
import type { IOrdersDateRange } from '@app/dashboard/types/innerLayout/orders';
import type { TAppliedRanges } from '@app/dashboard/types/innerLayout/date-ranges';
import { getLang } from '@app/dashboard/utils/localStorageUtils';
import { formatToISODate } from '@app/dashboard/utils/dateFormats';
import styles from './header.module.scss';

export const Header = ({
  setDateRange,
}: {
  setDateRange: Dispatch<SetStateAction<IOrdersDateRange>>;
}) => {
  const { t } = useTranslation();
  const lang = getLang();

  const wrapperRef = useRef<any>();

  const [appliedRanges, setAppliedRanges] = useState<TAppliedRanges>({});

  const formattedDates = (range: [Date, Date]): IOrdersDateRange => {
    const [formattedStartDate, formattedEndDate] = (range as [Date, Date])?.map(
      (date) => formatToISODate(date)
    );

    return { date_from: formattedStartDate, date_to: formattedEndDate };
  };

  const handleRangesChange = (ranges: TAppliedRanges) => {
    setAppliedRanges(ranges);
    const formattedDateRange = formattedDates([ranges.start, ranges.end] as [
      Date,
      Date
    ]);
    setDateRange(formattedDateRange);
  };

  return (
    <div className={styles['header']} ref={wrapperRef}>
      <div className={styles['header__title']}>
        {t('innerLayout.navbar.orders')}
      </div>

      <DateRanges
        appliedRanges={appliedRanges}
        handleRangesChange={handleRangesChange}
        lang={lang}
      />
    </div>
  );
};
